import clsx from "clsx";
import React from "react";

export type PillTab = {
  id: string;
  label: string;
  icon?: React.ReactNode;
  selected: boolean;
  onClick: () => void;
  disabled?: boolean;
};

type Props = {
  tabs: PillTab[];
  className?: string;
  /** Optional label rendered above the tab strip. Omit to hide it. */
  label?: string;
};

export default function PillTabs({ tabs, className, label }: Props) {
  const strip = (
    <div className={clsx("inline-flex items-center gap-[6px]", className)}>
      {tabs.map((tab) => (
        <button
          key={tab.id}
          type="button"
          onClick={tab.onClick}
          disabled={tab.disabled}
          className={clsx(
            "flex items-center gap-[6px] rounded-[6px] border-b-2 px-[12px] py-[8px] text-[14px] font-medium leading-[20px] transition-colors duration-300 ease-in-out",
            tab.selected
              ? "border-primary-600 bg-primary-200 text-primary-600"
              : "border-transparent bg-neutral-0 text-neutral-500 hover:text-neutral-700",
            tab.disabled ? "cursor-not-allowed opacity-50" : undefined,
          )}
        >
          {tab.icon ? (
            <span className="flex h-[20px] w-[20px] items-center justify-center">{tab.icon}</span>
          ) : null}
          <span>{tab.label}</span>
        </button>
      ))}
    </div>
  );

  if (!label) {
    return strip;
  }

  return (
    <div className="flex flex-col gap-1">
      <label className="block text-sm font-medium leading-6 text-neutral-700">{label}</label>
      {strip}
    </div>
  );
}
